export default __webpack_public_path__ + "static/1002-cbfd7e7ba9f66680c98bac1896d056fe.gif";